import { hasCapability, type User } from "../base";

export const automationUi = {
  read: (user: User) => hasCapability(user, "automationUi.read"),
};
